// bets

import styled from "@emotion/styled";
import { Box, Button, Divider, useTheme } from "@mui/material";
import { ColorUtils } from "fwork-jsts-common/src";
import React from "react";
import { NavigateOptions, To, useNavigate } from "react-router-dom";
import { RoutesNames } from "../../globals";

const MenuItemStyled = styled(Button)<{ selected?: boolean }>(({ theme, selected }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 10,
  padding: 10,
  borderRadius: 0,
  justifyContent: 'flex-start',
  whiteSpace: 'nowrap',
  width: '100%',
  color: 'white',
  background: selected ? ColorUtils.incColor('#5F6F94', 30) : 'transparent',
  position: 'relative',
  '&:hover': {
    background: '#5F6F94'
  },
}))

const MenuItemComponent = (props: {
  text: string,
  to: To,
  toOptions?: NavigateOptions,
  onItemClick?: () => void,
  styledItemDrawer?: boolean,
}) => {
  const navigate = useNavigate()
  let isHashRouter = location.href.includes('#')
  let route = isHashRouter ? location.hash.replaceAll('#', '') : location.pathname
  route = `/${route.split('/')[1]}`
  const selected = route == props.to.toString()

  const theme = useTheme()

  return <div style={{ position: 'relative', width: '100%', overflow: 'hidden' }}>
    <MenuItemStyled
      selected={selected}
      onClick={() => {
        if (props.onItemClick)
          props.onItemClick()
        navigate(props.to, props.toOptions)
      }}>
      {props.text}
    </MenuItemStyled>
    {selected && props.styledItemDrawer ? (
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: -1,
          clipPath: 'polygon(0 50%, 100% calc(100% + 1px), 100% -1px)',
          width: 20,
          height: 45,
          background: theme.palette.background.default,
          animation: 'slideIn 0.2s ease-in-out forwards, fadeIn 0.2s ease-in-out forwards',
        }}
      ></Box>
    ) : null}
    <style>
      {`
        @keyframes slideIn {
          0% {
            right: -20px;
          }
          100% {
            right: -1px;
          }
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      `}
    </style>
  </div>
}

export const MainMenuComponent = (props: {
  props?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  onItemClick?: () => void,
  styledDrawer?: boolean,
}) => {
  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    background: '#2B3467',
    height: '100%',
    boxSizing: 'border-box'
  }} {...props.props}>
    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      to={RoutesNames.events}
      onItemClick={props.onItemClick}
      text="Eventos"
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      to={RoutesNames.scoreTypes}
      onItemClick={props.onItemClick}
      text="Tipos de Resultados"
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      to={RoutesNames.participants}
      onItemClick={props.onItemClick}
      text="Participantes"
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Torneios"
      to={RoutesNames.tournaments}
      onItemClick={props.onItemClick}
    />

    <Divider />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Esportes"
      to={RoutesNames.sports}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Localizações"
      to={RoutesNames.locations}
      onItemClick={props.onItemClick}
    />

    <Divider />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Autorizações"
      to={RoutesNames.authorizations}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Grupos de Usuários"
      to={RoutesNames.usersGroups}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Usuários"
      to={RoutesNames.users}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Classificação de logs"
      to={RoutesNames.logsClassifications}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Logs"
      to={RoutesNames.logs}
      onItemClick={props.onItemClick}
    />

    <Divider />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Grupos de Empresas"
      to={RoutesNames.companiesGroups}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Empresas"
      to={RoutesNames.companies}
      onItemClick={props.onItemClick}
    />

    <MenuItemComponent
      styledItemDrawer={props.styledDrawer}
      text="Tarefas"
      to={RoutesNames.tasks}
      onItemClick={props.onItemClick}
    />
  </div>
}